import {Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {forkJoin} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Vessel, VesselsService, Voyage } from '../vessels.service';
import moment from 'moment';
import {KeycloakService} from 'src/app/authentication/keycloak.service';
import {DateRange} from 'src/app/shared/components/date-range.component';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import {DateTimeHelpers} from 'src/app/shared/helpers/date-time.helpers';
import _ from 'lodash';
import {saveAs} from 'file-saver';
import { MessageLevel, PgMessagesService } from '../../../shared/services/pg-messages.service';
import {
  PgDateRangeTitleComponent,
  PgDateRangeTitleEnum, PgTitleComponent
} from '../../../shared/components/title-bar/title-bar.component';
import { VesselReportToolbarComponent } from '../vessel-report-toolbar/vessel-report-toolbar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { mapToVoyageLength1, VoyageLength1 } from '../voyages.service';
import { UserLocalStoreService } from 'src/app/shared/services/user-local-store.service';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';

@Component({
  selector: 'app-voyages',
  templateUrl: './voyages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class VoyagesComponent implements OnInit, PgTitleComponent, PgDateRangeTitleComponent {

  title: EventEmitter<string> = new EventEmitter();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();

  toolbarComponentType = VesselReportToolbarComponent;
  toolbarComponent!: VesselReportToolbarComponent;
  voyagesLength!: VoyageLength1[];
  vessels!: Vessel[];
  dateRange: DateRange;
  gridOptions: GridOptions = {};
  gridRestored: boolean = false;

  voyageLengthFromLoadingToDischarge = VesselsService.voyageLengthFromLoadingToDischarge;
  calculateLaytime = VesselsService.calculateLaytime;
  calculateBerthTime = VesselsService.calculateBerthTime;
  organisationsMap!: Map<string, Organisation>;

  constructor(private _vesselsService: VesselsService,
              private _organisationService: OrganisationService,
              private _activatedRoute: ActivatedRoute,
              private _pgMessagesService: PgMessagesService,
              private _keycloakService: KeycloakService,
              private _router: Router,
              private _renderer: Renderer2,
              private _voyagesService: VoyageServiceSpa,
              private _userLocalStorage: UserLocalStoreService,) {
    this.dateRange = {
      startDate: moment().subtract(12, 'months').toDate(),
      endDate: moment().toDate()
    };
  }

  hasRole(role: string) {
    return this._keycloakService.hasRole(role);
  }

  navigate(_router: Router, voyage: Voyage) {
    _router.navigate(['/vessels/voyage', voyage.id]);
  }

  navigateVessel(_router: Router, voyage: Voyage) {
    _router.navigate(['/vessels/vessel', voyage.vesselImo]);
  }

  columnDefs = [
    { headerName: 'Vessel',
      cellRenderer: (params:ICellRendererParams) => {
        const vesselName = (params.data.voyage.vesselName) ? params.data.voyage.vesselName : 'Edit';
        return AgGridService.editButtonWithText(
          this._renderer,
          this._router,
          this.navigateVessel,
          params.data.voyage,
          vesselName);
      },
      valueGetter: (params:ICellRendererParams) => params.data.voyage.vesselName || 'Edit',
      filterValueGetter: (params:ICellRendererParams) => params.data.voyage?.vesselName || '',
      width: 100, minWidth: 50
    },

    { headerName :'Voyage',
      cellRenderer: (params:ICellRendererParams) => {
        const shipVoyageNumber = (params.data.voyage.shipVoyageNo) ? params.data.voyage.shipVoyageNo : 'Edit';
        return AgGridService.editButtonWithText(
          this._renderer,
          this._router,
          this.navigate,
          params.data.voyage,
          shipVoyageNumber);
      },
      valueGetter: (params:ICellRendererParams) => params.data.voyage.shipVoyageNo || 'Edit',
      filterValueGetter: (params:ICellRendererParams) =>params.data.voyage.shipVoyageNo || '',
      width: 100, minWidth: 50
    },
    { headerName :' Loading',
      valueFormatter: (params:ICellRendererParams) => `${this.formatNorDates(params.data.voyage, 'loading')}
        ${this.formatNorPort(params.data.voyage, 'loading')}`,
      filterValueGetter: (params:ICellRendererParams) => `${this.formatNorDates(params.data.voyage, 'loading')}
        ${this.formatNorPort(params.data.voyage, 'loading')}`,
      width: 300, minWidth: 150
    },
    { headerName :'Discharge',
      valueFormatter: (params:ICellRendererParams) => `
        ${this.formatNorDates(params.data.voyage, 'discharging')}
        ${this.formatNorLocation(params.data.voyage, 'discharging')}
        ${this.formatNorPort(params.data.voyage, 'discharging')}`,
      filterValueGetter: (params: ICellRendererParams) => `
        ${this.formatNorDates(params.data.voyage, 'discharging')}
        ${this.formatNorLocation(params.data.voyage, 'discharging')}
        ${this.formatNorPort(params.data.voyage, 'discharging')}`,
      width: 300, minWidth: 150
    },
    // { headerName :'Discharge Country',
    //   valueFormatter: (params) => this.formatNorLocation(params.data.voyage, 'discharging'),
    //   filterValueGetter: (params) => this.formatNorLocation(params.data.voyage, 'discharging'),
    // },
    // { headerName :'Discharge Port',
    //   cellRenderer: (params) => this.formatNorPort(params.data.voyage, 'discharging')
    // },
    // { headerName :'Last B/L date',
    //   cellRenderer: (params) => this.formatProductDates(params.data.voyage)
    // },
    { headerName :'Sum of Real',
      cellRenderer: (params:ICellRendererParams) => this.formatProductWeights(params.data.voyage),
      width: 150, minWidth: 50
    },
    // { headerName :'Sum of Revise',
    //   cellRenderer: (params) => this.formatReviseWeights(params.data.voyage)
    // },
    // { headerName :'Last Discharge',
    //   cellRenderer: (params) => this.formatDischargeDates(params.data.voyage)
    // },
    { headerName :'Ports 1',
      cellRenderer: (params:ICellRendererParams) => `${this._vesselsService.countPorts(params.data.voyage, 'loading')} / ${this._vesselsService.countPorts(params.data.voyage, 'discharge')}`,
      width: 100, minWidth: 50
    },
    { headerName :'Berth time 2',
      cellRenderer: (params:ICellRendererParams) => this.calculateBerthTime(params.data.voyage, 'loading'),
      width: 100, minWidth: 50
    },
    { headerName :'Len 3',
      cellRenderer: (params:ICellRendererParams) => this.voyageLengthFromLoadingToDischarge(params.data.voyage),
      width: 100, minWidth: 50
    },
    { headerName :'Len 4', field:'days', width: 100, minWidth: 50
    },
    { headerName :'Total LT',
      cellRenderer: (params:ICellRendererParams) => `${this.calculateLaytime(params.data.voyage, 'loading')} / ${this.calculateLaytime(params.data.voyage, 'discharge')}`,
      width: 100, minWidth: 50
    }
  ];

  ngOnInit() {
    this.getParameters();
    this.gridOptions = AgGridService.getOptions();
    this.toolbarComponent.date.subscribe(dateRange => {
      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router
          .navigate(['vessels/voyages/'], {
            queryParams: {
              startTime: dateRange?.startDate.getTime(),
              endTime: dateRange?.endDate.getTime()
            }
          })
          .then((e) => console.log(`Result of Navigation is ${e}`));
      });
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  saveGridState(event: GridReadyEvent) {
    AgGridService.saveGridState(event, this.gridRestored, this._userLocalStorage, 'voyageGrid');
  }

  restoreGridState(event: GridReadyEvent) {
    this.gridRestored = AgGridService.restoreGridState(event, this._userLocalStorage, 'voyageGrid');
  }

  getParameters() {
    this._activatedRoute.queryParams.subscribe(p => {
      const startDate = p['startTime'] ? +p['startTime'] : moment().subtract(1, 'year').toDate().getTime();
      const endDate = p['endTime'] ? +p['endTime'] : new Date() ;
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
      this.toolbarComponent.dateRange = this.dateRange;
      this.title.emit('Voyages');
      this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.defaultTitle]);
      this.changeReportPeriod();
    });
  }

  findOrganisation(organisationId: string) {
    const org = this.organisationsMap.get(organisationId);
    if (typeof org !== 'undefined') {
      return org.nameTranslations['en'];
    } else {
      return '';
    }
  }

  formatNorDates(voyage: Voyage, norType: string) {
    const nors = voyage.nors.filter(n => n.norType === norType);
    if (nors && nors.length > 0 && this.organisationsMap) {
      const dt = nors.map(v => v.timestamp).sort((l1, l2) => l2 - l1)[0];
      const timezone = this.organisationsMap.get(voyage.nors.filter(v => v.timestamp === dt)[0].portOrganisationId)!
        .timezone;
      return  DateTimeHelpers.getDateTimeFromTimestamp(timezone, dt);
    } else {
      return '';
    }
  }

  formatProductDates(voyage: Voyage) {
    if (voyage.billOfLadings && voyage.billOfLadings.length > 0) {
      const dt = voyage.billOfLadings.map(b => b.date).sort((l1, l2) => l2 - l1)[0];
      const timezone = this.organisationsMap.get(voyage.billOfLadings.filter(v => v.date === dt)[0].loadingPortOrganisationId)!
        .timezone;
      return  DateTimeHelpers.getDateTimeFromTimestamp(timezone, dt);
    } else {
      return '';
    }
  }

  formatProductWeights(voyage: Voyage) {
    if (voyage.billOfLadings) {
      const result = voyage.billOfLadings.filter(bill => bill.revise !== true)
        .map(b => b.products?.map(p => p.grossWeight).reduce((x, y) => x + y, 0))
        .reduce((m, n) => m + n, 0);
      return (Math.round(result * 1000) / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  formatReviseWeights(voyage: Voyage) {
    if (voyage.billOfLadings) {
      const result =  voyage.billOfLadings.filter(bill => bill.revise === true)
        .map(b => b.products?.map(p => p.grossWeight).reduce((x, y) => x + y, 0))
        .reduce((m, n) => m + n, 0);
      return (Math.round(result * 1000) / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  formatDischargeDates(voyage: Voyage) {
    if (voyage.discharges && voyage.discharges.length > 0) {
      const dt = voyage.discharges.map(b => b.date).sort((l1, l2) => l2 - l1)[0];
      const timezone = this.organisationsMap.get(voyage.discharges.filter(v => v.date === dt)[0].portOrganisationId)!
        .timezone;
      return  DateTimeHelpers.getDateFromTimestamp(timezone, dt);
    } else {
      return '';
    }
  }

  selectedDateRangeChanged(dateRange: DateRange) {
    this.dateRange.startDate = dateRange.startDate;
    this.dateRange.endDate = dateRange.endDate;
  }

  changeReportPeriod() {
    forkJoin([
      this._voyagesService.getAllVoyagesBetween({
        startTime: this.dateRange.startDate.toString(),
        endTime: this.dateRange.endDate.toString()
      }
      ),
      this._vesselsService.getVessels(),
      this._organisationService.get()
    ]).subscribe(results => {
      this.vessels = results[1];
      this.voyagesLength = mapToVoyageLength1(results[0].voyages);
      this.organisationsMap = new Map(results[2].map(o => [o.name, o]));
    });
  }

  downloadFile() {
    this._vesselsService.downloadVoyageActivityExcel(this.dateRange.startDate.getTime(),
      this.dateRange.endDate.getTime()).subscribe(b => {
      saveAs(b.body ?? '', `${DateTimeHelpers.formatLocalDate(this.dateRange.startDate.getTime())}-to-` +
          `${DateTimeHelpers.formatLocalDate(this.dateRange.endDate.getTime())}-voyages-activity-report.xlsx`);
    }, () => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Error,
        message: 'Could not download excel report',
        topic: 'Voyages report'
      });
    });
  }

  formatNorLocation(voyage: Voyage, norType: string) {
    if (voyage.nors) {
      const dischargeNors = voyage.nors.filter(n => n.norType === norType);
      if (dischargeNors) {
        return _.chain(dischargeNors.map(n => n.portOrganisationId.split('.')[0])
          .map(o => this.findOrganisation(o))).groupBy(i => i).map((items, k) => k).value().join(', ');
      }
    }
    return '';
  }

  formatNorPort(voyage: Voyage, norType: string) {
    if (voyage.nors) {
      const dischargeNors = voyage.nors.filter(n => n.norType === norType);
      if (dischargeNors) {
        return _.chain(dischargeNors)
          .map(o => this.findOrganisation(o.portOrganisationId))
          .groupBy(i => i).map((items, k) => k).value().join(', ');
      }
    }
    return '';
  }
}